var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDuplicate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 440.001 440.001",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M404.624,134.918l-60.975-60.977c-1.346-1.346-3.17-2.1-5.072-2.1h-27.1v-3.693c0-1.904-0.756-3.726-2.103-5.073 L248.4,2.101C247.057,0.756,245.232,0,243.33,0H54.794C42.93,0,33.278,9.651,33.278,21.516v325.125 c0,11.863,9.652,21.518,21.516,21.518h73.73v50.326c0,11.862,9.652,21.516,21.515,21.516h235.167 c11.865,0,21.517-9.651,21.517-21.516V139.988C406.724,138.087,405.968,136.263,404.624,134.918z M57.186,23.907h174.354v48.577 c0,4.905,3.977,8.881,8.879,8.881h47.152l0.012,262.886H57.186V23.907z M152.431,416.093v-47.935h137.53 c11.863,0,21.517-9.652,21.517-21.517V95.749h15.309v48.578c0,4.902,3.978,8.878,8.879,8.878h47.154l0.01,262.888H152.431 L152.431,416.093z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.589,348.396h-16.743c-3.203,0-5.812,2.604-5.812,5.811v42.729c0,3.204,2.607,5.812,5.812,5.812h16.743 c15.275,0,27.701-12.178,27.701-27.146C371.29,360.602,358.864,348.396,343.589,348.396z M343.589,390.513H333.27v-29.882h10.319 c8.529,0,15.47,6.717,15.47,14.973C359.058,383.823,352.118,390.513,343.589,390.513z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuplicate);
export default __webpack_public_path__ + "static/media/duplicate.1572c846b3843f441e28789219621905.svg";
export { ForwardRef as ReactComponent };